module.exports = __webpack_public_path__ + "media/customizations/experiencesevenoaks/logo-69087e6332b6e2e23d2fde03c39e0ece.png";